export default __webpack_public_path__ + "img/dahla_e-log.9c39773c.png";